import { render, staticRenderFns } from "./KomoditiMain.vue?vue&type=template&id=110714f8&scoped=true"
import script from "./KomoditiMain.vue?vue&type=script&lang=js"
export * from "./KomoditiMain.vue?vue&type=script&lang=js"
import style0 from "./KomoditiMain.vue?vue&type=style&index=0&id=110714f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110714f8",
  null
  
)

export default component.exports